/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export interface ToolGroup {
    key: string,
    keyIcon: string,
    apps: string[],
    items: ToolItem[]
}

export interface ToolItem {
    itemName: string,
    itemIcon: string,
    items: MenuItem[],
    isSelected?: boolean
}

export interface MenuItem {
    itemName: string,
    itemIcon: string,
    disabled?: boolean
}